import styled from "styled-components";

export const StyledDeleteWrapper = styled.div`
    cursor: pointer;
`;
